// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b8fb2d96","732":"26853768","977":"9daccf9d"}[chunkId] + ".chunk.js";
};